import { ref, computed, watch, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-50a68cbe"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "lawyer-board"
};
const _hoisted_2 = {
  class: "product-panel"
};
import { message } from 'ant-design-vue';
import { OK } from '@/common';
import { updateProductCustomName, updateProductQueryTime } from '@/api/lawyerBoard';
import AccountPanel from './components/AccountPanel.vue';
import AddAccountModal from './components/AddAccountModal.vue';
import ProductFilter from './components/ProductFilter.vue';
import ProductTable from './components/ProductTable.vue';
import BatchCustomNameModal from './components/BatchCustomNameModal.vue';
import BatchQueryTimeModal from './components/BatchQueryTimeModal.vue';
import { useAccountList } from './hooks/useAccountList';
import { useProductList } from './hooks/useProductList';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      accounts,
      displayAccounts,
      keyword: accountKeyword,
      loading: accountLoading,
      selectedAccountId,
      selectAccount,
      load: loadAccounts,
      addAccount,
      removeAccount
    } = useAccountList();
    const {
      keyword: productKeyword,
      list: productList,
      loading: productLoading,
      pageTotal,
      pageIndex,
      pageSize,
      currentPageSizeChange,
      selectedRowKeys,
      clearSelection,
      search: handleSearch,
      reset: handleReset,
      reloadForAccount,
      refresh: refreshProducts
    } = useProductList(selectedAccountId);
    const addModalRef = ref();
    const batchNameRef = ref();
    const batchTimeRef = ref();
    const addModalOpen = ref(false);
    const batchNameOpen = ref(false);
    const batchTimeOpen = ref(false);
    /** 下拉选中的是 SSO 用户，重复添加校验按 ssoUserId 比对 */
    const existedAccountIds = computed(() => accounts.value.map(item => item.ssoUserId));
    const handleSelectAccount = accountId => selectAccount(accountId);
    /** 切换账号后清空产品筛选条件与勾选状态并重新加载 */
    watch(selectedAccountId, () => {
      reloadForAccount();
    });
    const handleAddAccount = async user => {
      var _addModalRef$value;
      (_addModalRef$value = addModalRef.value) === null || _addModalRef$value === void 0 || _addModalRef$value.setSubmitting(true);
      try {
        const ok = await addAccount(user);
        if (ok) {
          var _addModalRef$value2;
          message.success('新增成功');
          (_addModalRef$value2 = addModalRef.value) === null || _addModalRef$value2 === void 0 || _addModalRef$value2.close();
        }
      } finally {
        var _addModalRef$value3;
        (_addModalRef$value3 = addModalRef.value) === null || _addModalRef$value3 === void 0 || _addModalRef$value3.setSubmitting(false);
      }
    };
    const handleDeleteAccount = async accountId => {
      const ok = await removeAccount(accountId);
      if (ok) {
        message.success('删除成功');
      }
    };
    const handleSaveName = async payload => {
      const res = await updateProductCustomName({
        accountId: selectedAccountId.value,
        productIds: [payload.productId],
        customName: payload.customName
      });
      if (res && res.code === OK) {
        message.success('保存成功');
        await refreshProducts();
      }
    };
    const handleSaveTime = async payload => {
      const res = await updateProductQueryTime({
        accountId: selectedAccountId.value,
        productIds: [payload.productId],
        queryTimeMode: payload.queryTimeMode,
        timeRanges: payload.timeRanges
      });
      if (res && res.code === OK) {
        message.success('保存成功');
        await refreshProducts();
      }
    };
    const handleBatchName = async customName => {
      var _batchNameRef$value;
      (_batchNameRef$value = batchNameRef.value) === null || _batchNameRef$value === void 0 || _batchNameRef$value.setSaving(true);
      try {
        const res = await updateProductCustomName({
          accountId: selectedAccountId.value,
          productIds: [...selectedRowKeys.value],
          customName
        });
        if (res && res.code === OK) {
          var _batchNameRef$value2;
          message.success('保存成功');
          (_batchNameRef$value2 = batchNameRef.value) === null || _batchNameRef$value2 === void 0 || _batchNameRef$value2.close();
          await refreshProducts();
          clearSelection();
        }
      } finally {
        var _batchNameRef$value3;
        (_batchNameRef$value3 = batchNameRef.value) === null || _batchNameRef$value3 === void 0 || _batchNameRef$value3.setSaving(false);
      }
    };
    const handleBatchTime = async payload => {
      var _batchTimeRef$value;
      (_batchTimeRef$value = batchTimeRef.value) === null || _batchTimeRef$value === void 0 || _batchTimeRef$value.setSaving(true);
      try {
        const res = await updateProductQueryTime({
          accountId: selectedAccountId.value,
          productIds: [...selectedRowKeys.value],
          queryTimeMode: payload.queryTimeMode,
          timeRanges: payload.timeRanges
        });
        if (res && res.code === OK) {
          var _batchTimeRef$value2;
          message.success('保存成功');
          (_batchTimeRef$value2 = batchTimeRef.value) === null || _batchTimeRef$value2 === void 0 || _batchTimeRef$value2.close();
          await refreshProducts();
          clearSelection();
        }
      } finally {
        var _batchTimeRef$value3;
        (_batchTimeRef$value3 = batchTimeRef.value) === null || _batchTimeRef$value3 === void 0 || _batchTimeRef$value3.setSaving(false);
      }
    };
    onMounted(() => {
      loadAccounts();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(AccountPanel, {
        keyword: _unref(accountKeyword),
        "onUpdate:keyword": _cache[0] || (_cache[0] = $event => _isRef(accountKeyword) ? accountKeyword.value = $event : null),
        accounts: _unref(displayAccounts),
        loading: _unref(accountLoading),
        "selected-account-id": _unref(selectedAccountId),
        onSelect: handleSelectAccount,
        onAdd: _cache[1] || (_cache[1] = $event => addModalOpen.value = true),
        onDelete: handleDeleteAccount
      }, null, 8, ["keyword", "accounts", "loading", "selected-account-id"]), _createElementVNode("div", _hoisted_2, [_createVNode(ProductFilter, {
        keyword: _unref(productKeyword),
        "onUpdate:keyword": _cache[2] || (_cache[2] = $event => _isRef(productKeyword) ? productKeyword.value = $event : null),
        "selected-count": _unref(selectedRowKeys).length,
        onSearch: _unref(handleSearch),
        onReset: _unref(handleReset),
        onBatchName: _cache[3] || (_cache[3] = $event => batchNameOpen.value = true),
        onBatchTime: _cache[4] || (_cache[4] = $event => batchTimeOpen.value = true)
      }, null, 8, ["keyword", "selected-count", "onSearch", "onReset"]), _createVNode(ProductTable, {
        selectedRowKeys: _unref(selectedRowKeys),
        "onUpdate:selectedRowKeys": _cache[5] || (_cache[5] = $event => _isRef(selectedRowKeys) ? selectedRowKeys.value = $event : null),
        list: _unref(productList),
        loading: _unref(productLoading),
        "page-index": _unref(pageIndex),
        "page-size": _unref(pageSize),
        total: _unref(pageTotal),
        onPageChange: _unref(currentPageSizeChange),
        onSaveName: handleSaveName,
        onSaveTime: handleSaveTime
      }, null, 8, ["selectedRowKeys", "list", "loading", "page-index", "page-size", "total", "onPageChange"])]), _createVNode(AddAccountModal, {
        ref_key: "addModalRef",
        ref: addModalRef,
        open: addModalOpen.value,
        "onUpdate:open": _cache[6] || (_cache[6] = $event => addModalOpen.value = $event),
        "existed-ids": _unref(existedAccountIds),
        onSubmit: handleAddAccount
      }, null, 8, ["open", "existed-ids"]), _createVNode(BatchCustomNameModal, {
        ref_key: "batchNameRef",
        ref: batchNameRef,
        open: batchNameOpen.value,
        "onUpdate:open": _cache[7] || (_cache[7] = $event => batchNameOpen.value = $event),
        count: _unref(selectedRowKeys).length,
        onSubmit: handleBatchName
      }, null, 8, ["open", "count"]), _createVNode(BatchQueryTimeModal, {
        ref_key: "batchTimeRef",
        ref: batchTimeRef,
        open: batchTimeOpen.value,
        "onUpdate:open": _cache[8] || (_cache[8] = $event => batchTimeOpen.value = $event),
        count: _unref(selectedRowKeys).length,
        onSubmit: handleBatchTime
      }, null, 8, ["open", "count"])]);
    };
  }
});